export const EMPLOYEE_ROUTES_PATHS = {
  PROFILE: 'profile',
  JOBS: 'jobs',
  DOCUMENTS: 'documents',
  REGISTRATION: 'registration',
  SKILLS: 'skills',
  LANGUAGES: 'languages',
} as const;

export const EMPLOYEE_ROUTES_PARAMS = {
  EMPLOYEE_ID: 'employeeId',
} as const;
